import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Banner } from '../_models/banner';

@Injectable({
  providedIn: 'root'
})
export class HomeProductService {

  constructor(
  private http: HttpClient
  ) { }
  public static readonly GET_BANNER_PRODUCT = environment.apiURL + 'getBannerProduct';
  public static readonly GET_PRODUCT = environment.apiURL + 'getFeaturedProduct';


  getBannerProduct(): Observable<Banner[]> {
    return this.http.get<Banner[]>(HomeProductService.GET_BANNER_PRODUCT);
  }

  getProducts(): Observable<any[]> {
    return this.http.get<any[]>(HomeProductService.GET_PRODUCT);
  }

}
